import React, { Component, useContext } from 'react';
import {CapabilityContext} from "../global/context/CapabilityContext";
import Row from "@amzn/meridian/row";
import Heading from "@amzn/meridian/heading";
import Breadcrumb, { BreadcrumbGroup } from "@amzn/meridian/breadcrumb";
import { getFCLMLink } from "../util/Util";
import Table, {
    TableRow,
    TableCell,
} from "@amzn/meridian/table"
import Link from "@amzn/meridian/link";
import { getStationCode } from '../network/NetworkUtil';
class AssociateList extends Component {

    render() {
        let urlRouteCode = this.props.match.params.routeCode;
        let urlList = this.props.match.params.associateList;
        const associateList = urlList != null ? urlList.split(",") : [];
        const routeCode = urlRouteCode != null ? urlRouteCode : "";
        const {configViewModel} = useContext(CapabilityContext)
        const stationCode = getStationCode();

        return (
            <div>
                <Row widths="100%" spacingInset="large large small">
                    <BreadcrumbGroup>
                        <Breadcrumb href="#pick">Pick</Breadcrumb>
                        <Breadcrumb>Associate List</Breadcrumb>
                    </BreadcrumbGroup>
                </Row>
                <Row width="100%" spacingInset="medium large medium large">
                    <Heading level={3} type="h600" alignment="left">Route - {routeCode}</Heading>
                </Row>
                <Row width="100%" spacingInset="medium large medium large">
                    <Table headerRows={1} spacing="small">
                        <TableRow key={"header"}>
                            <TableCell>Associate</TableCell>
                        </TableRow>
                        {
                            associateList.map((associate) => (
                                <TableRow key={associate}>
                                    <TableCell sortColumn="associate">
                                        <Link href={getFCLMLink(associate, configViewModel.stationConfig.fclmLinkEnabled, stationCode)} type="secondary" target="_blank" el="noreferrer noopener">
                                            {associate}
                                        </Link>
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                    </Table>
                </Row>

            </div>
        )
    }
}

export default AssociateList;


// WEBPACK FOOTER //
// ./src/components/pickStatus/AssociateList.js